import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Marquee";
import { Suggested } from "@/components/site/Suggested";
import { Menu } from "@/components/site/Menu";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { Videos } from "@/components/site/Videos";
import { Reviews } from "@/components/site/Reviews";
import { StructuredData } from "@/components/site/StructuredData";
import { Location } from "@/components/site/Location";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function LandingPage() {
  useLenis();
  const [content, setContent] = useState(null);
  const [menu, setMenu] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/content"), api.get("/menu"), api.get("/gallery"), api.get("/reviews")]).then(
      ([c, m, g, r]) => {
        setContent(c.data);
        setMenu(m.data);
        setGallery(g.data);
        setReviews(r.data);
      }
    );
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <span className="font-display uppercase text-2xl text-[#FF5A00] animate-pulse">El Rey del Sabor</span>
      </div>
    );
  }

  return (
    <div className="grain min-h-screen bg-[#0A0A0A]">
      <Header content={content} />
      <Hero content={content} />
      <Ribbon />
      <Suggested items={menu} />
      <Menu items={menu} />
      <About content={content} />
      <Gallery items={gallery} />
      <Videos content={content} />
      <Reviews content={content} reviews={reviews} />
      <Location content={content} />
      <Footer content={content} />
      <WhatsAppButton content={content} />
      <StructuredData content={content} reviews={reviews} />
    </div>
  );
}
